// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.JPG = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.JPG = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var JPG = _exports.JPG = function JPG(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M16.927 8.496v8.43a2.08 2.08 0 0 1-2.078 2.079H5.152a2.08 2.08 0 0 1-2.078-2.078V3.074A2.08 2.08 0 0 1 5.152.996h4.275c.367 0 .72.146.98.406l6.114 6.115c.26.26.406.612.406.98Z"
    }), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M10 1.342v5.195a1.385 1.385 0 0 0 1.385 1.385h5.195"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M6.666 12.05v2.514c-.002.314-.14.48-.393.48-.241 0-.389-.155-.398-.437H5c-.004.783.543 1.129 1.223 1.129.771 0 1.307-.464 1.309-1.172V12.05zM8.084 15.686h.879v-1.13h.596c.833 0 1.353-.493 1.353-1.247 0-.748-.51-1.26-1.326-1.26H8.084zm.879-1.822v-1.106h.433c.394 0 .605.213.605.55 0 .336-.21.556-.605.556zM13.732 13.238h.89c-.09-.725-.736-1.238-1.577-1.238-.972 0-1.739.684-1.739 1.873 0 1.15.707 1.863 1.75 1.863.935 0 1.604-.58 1.604-1.557v-.482h-1.567v.641h.72c-.008.384-.275.627-.75.627-.546 0-.86-.403-.86-1.102 0-.695.332-1.092.86-1.092.351 0 .59.172.669.467"
    }));
  };
});
